import type { BlogPost } from "./BlogPostPage";

export const doorwayBlogAuthor: BlogPost["author"] = {
  name: "Nick Lafferty",
  role: "Founder, Doorway",
  image: "/author-images/nick-lafferty.jpg",
  website: "https://nicklafferty.com",
  linkedin: "https://www.linkedin.com/in/nicklafferty/",
  twitter: "https://x.com/nicklafferty",
  bio: [
    { text: "Nick Lafferty is the Founding Marketing Engineer at Profound and the founder of " },
    { text: "Plink", href: "https://justplink.com" },
    { text: ", a super lightweight HEIC to JPG converter for your Mac. He also hosts the " },
    {
      text: "Marketing Engineer Podcast",
      href: "https://www.tryprofound.com/blog/marketing-engineer-podcast",
    },
    { text: ". Before that, he led growth at Loom and built a $30k/mo consulting business." },
  ],
};

export const doorwayTeamsPostPath = "/blog/from-single-player-to-multiplayer";

export const doorwayTeamsPost: BlogPost = {
  path: doorwayTeamsPostPath,
  title: "From single-player to multiplayer: the hard part starts after your app works",
  description: "Building an app for yourself is easy. Giving your whole team a safe, reliable way to use it introduces a much bigger set of problems.",
  publishedAt: "2026-07-18",
  author: doorwayBlogAuthor,
  image: "/header-images/doorway-blog-hero-minimal.png",
  imageAlt: "A project folder ready to publish, with its Doorway link, team sharing, and synced skills shown below.",
  imageWidth: 3200,
  imageHeight: 2000,
  readingTime: "5 min read",
  featured: false,
  tags: ["marketing engineering", "internal apps", "team collaboration", "Doorway Teams"],
  faqs: [
    {
      question: "What changes when an internal app gets a second user?",
      answer: "The app needs a stable home, individual identity, clear authorization, private access, shared ownership, a place to be discovered, and a reliable offboarding process.",
    },
    {
      question: "How is Doorway planning to control access to team apps?",
      answer: "Doorway Teams uses Google sign-in with an explicit workspace access policy. Admins approve specific email addresses or a verified Google Workspace domain, while Doorway separately enforces which apps each person may use.",
    },
    {
      question: "What does Doorway Teams include?",
      answer: "Doorway Teams gives a company a private workspace for its apps, with Google sign-in, shared ownership, approved viewers, creator roles, offboarding, and audit history.",
    },
  ],
};
